import type { CreateUserResponse as CreateUserType } from '@otter-ai/recall-client';
import { useHandleEmailSignupSuccess } from '#hooks';
import { useCreateUserMutation } from '#mutation';

export const useCreateUser = ({
  skipRedirect = false,
  skipHandleSignupSuccess = false,
  onSuccess,
  onError,
}: {
  skipRedirect?: boolean;
  skipHandleSignupSuccess?: boolean;
  onSuccess?: (res: CreateUserType) => void;
  onError?: (error: Error) => void;
}) => {
  const { handleEmailSignupSuccess } = useHandleEmailSignupSuccess({
    skipRedirect,
    skipHandleSignupSuccess,
  });

  const {
    mutate: createUser,
    mutateAsync: createUserAsync,
    isPending: isCreatingUser,
  } = useCreateUserMutation({
    onSuccess: async (res) => {
      await handleEmailSignupSuccess(res);

      if (onSuccess) {
        onSuccess(res);
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return { createUser, createUserAsync, isCreatingUser };
};
